export const userTypeMap: Record<'platformUser' | 'entityUser', UserType> = {
  platformUser: 0,
  entityUser: 1,
}
export const businessLineTextMap: Record<BusinessType, string> = {
  1: '单车',
  2: '电单车',
  3: '双业务',
}
export const businessLineMap: Record<'bike' | 'spock' | 'double', BusinessType> = {
  bike: 1,
  spock: 2,
  double: 3,
}
export const bikeStatusMap: Record<'all' | 'moving' | 'parking', BikeStatus> = {
  all: 3,
  moving: 1,
  parking: 2,
}
export const bikeStatusTextMap: Record<BikeStatus, string> = {
  3: '全部',
  1: '骑行中',
  2: '停放中',
}
export const bikeViolationStatusMap = {
  all: 3,
  moving: 1,
  violation: 5,
  normal: 4,
}
export const bikeViolationStatus = [
  { label: '骑行中', value: 1 },
  { label: '违停中', value: 5 },
  { label: '合规停放中', value: 4 },
  { label: '全部', value: 3 },
]
export const bikeParkingStatusMap: Record<'inFence' | 'outFence', BikeParkingStatus> = {
  inFence: 1,
  outFence: 2,
}
export const bikeParkingStatusTextMap: Record<BikeParkingStatus, string> = {
  1: '停车点内',
  2: '停车点外',
}
export const parkingAreasMap = {
  parking: 1,
  noParking: 2,
  operationArea: 4,
  all: 3,
}
export const parkingAreasTextMap = {
  1: 'P点',
  2: '禁停区',
  4: '运营区',
  3: '全部',
}
export const operateStatusMap = {
  operator: 1,
  operationCar: 2,
  all: 3,
}
export const operateStatusTextMap = {
  1: '运维人员',
  2: '运维车辆',
  3: '全部',
}
export const heatStatusMap = {
  start: 1,
  vehicle: 2,
  destination: 3,
}
export const heatStatusTextMap = {
  1: '出发地热力图',
  2: '车辆热力图',
  3: '目的地热力图',
}

export const timePeriodMap = {
  today: 0,
  seven: 7,
  thirity: 30,
  year: 365,
}

export const timePeriodTextMap = {
  0: '今天',
  7: '近7天',
  30: '近30天',
  365: '近365天',
}

export const dimensionItemMap = {
  thisYear: 1,
  cumulative: 2,
}

export const dimensionItemTextMap = {
  1: '今年',
  2: '累计',
}

export const registerMap = {
  default: 0,
  yes: 1,
  no: 2,
}

export const districtLevelMap = {
  country: 2,
  province: 4,
  city: 5,
  area: 6,
  street: 7,
  school: 8,
}

export const complaintStatusMap = {
  publish: 100,
  feedbackResponse: 200,
  feedbackArrive: 300,
  feedbackFinish: 400,
  finish: 500,
}

export const complaintStatusTextMap = {
  100: { text: '待响应', color: 'red' },
  200: { text: '已响应', color: 'red' },
  300: { text: '已到场', color: 'yellow' },
  400: { text: '已处理完成', color: 'green' },
  500: { text: '已完成', color: 'green' },
}

export const bikeCardStatusTextMap = {
  1: '牌照完整',
  2: '牌照丢失',
  3: '牌照损坏',
}

export const whitelistTypeMap = {
  city: { label: '全市整体调优', value: 5 },
  area: { label: '分区县调优', value: 6 },
}

export const whitelistTypeAreaMap = {
  area: { label: '全区整体调优', value: 6 },
  street: { label: '分街道调优', value: 7 },
}

export const whitelistTypeSepMap = {
  automatic: { label: '自动白名单', value: 0 },
  manual: { label: '手动白名单', value: 1 },
}

export const interfacePushTypeMap = {
  manual: { label: '手动', value: 1 },
  automatic: { label: '自动', value: 2 },
}

export const manualPushTypeMap = {
  filePush: { label: '文件推送', value: 1 },
  notFilePush: { label: '非文件推送', value: 0 },
  timingPush: { label: '定时任务推送', value: 2 },
}

export const manualPushStatusMap = {
  processing: { label: '执行中', value: 1 },
  done: { label: '成功', value: 2 },
  interrupt: { label: '中断', value: 3 },
}

export const pushTypeMap = {
  remove: { label: '删除数据', value: 5 },
  update: { label: '更新增量数据', value: 4 },
  replace: { label: '更新全量数据', value: 6 },
}

// 停车点淤积程度
export const siltingUpStatusMap = {
  high: { label: '高', value: 3, color: 'red' },
  middle: { label: '中', value: 2, color: 'yellow' },
  low: { label: '低', value: 1, color: 'green' },
  normal: { label: '正常', value: 0, color: 'green' },
}

export const echartColors = [
  '#269AFF',
  '#FAD60D',
  '#F18C11',
  '#ACE5AA',
  '#47C5A2',
  '#936FF5',
  '#96ADFA',
  '#9E7068',
  '#DDBFA7',
  '#EF8B99',
]

export const regExpMap = {
  // 整数
  int: /^-?[1-9]\d*$/,
  // 正整数
  posInt: /^[1-9]\d*$/,
  posIntAndZero: /^([1-9]\d*|0)$/,
  // 座机
  phone: /^0\d{2,3}-?\d{7,8}$/,
  // 手机号
  mobile: /^((\+?86)|(\(\+86\)))?(1\d{10}$)$/,
  // 脱敏手机号
  secureMobile: /^((\+?86)|(\(\+86\)))?(1\d{2}(\*|\d){4}\d{4}$)$/,
  // 身份证
  idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  // 邮箱
  email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
  // 中文姓名
  name: /[\u4E00-\u9FA5\uF900-\uFA2D]/,
  // ip 地址
  ip: /((2((5[0-5])|([0-4]\d)))|([0-1]?\d{1,2}))(\.((2((5[0-5])|([0-4]\d)))|([0-1]?\d{1,2}))){3}/,
  webSite: /^https?:\/\/\S+$/i,
}

// 广州演示特定实体
let YANSHI_ID = 480
if (location.origin.indexOf('api.bike.test.sankuai.com') > -1) {
  YANSHI_ID = 2083
} else if (
  location.origin.indexOf('api.bike.st.sankuai.com') > -1 ||
  location.origin.indexOf('bike.meituan.com') > -1
) {
  YANSHI_ID = 480
}

export const GUANGZHOU_YANSHI_ID = YANSHI_ID

// https://km.sankuai.com/page/1212277772
export type ResourceMapKeys = keyof typeof resourceMap
export type ResourceMap = {
  [K in ResourceMapKeys]: Record<keyof (typeof resourceMap)[K], UserResource | null>
}
export type ResourceMap2 = Record<
  ResourceMapKeys,
  Record<keyof ResourceMapKeys, UserResource | null>
>
export const resourceMap = {
  // 数据中心
  dataCenter: {
    // 首页
    index: 1,
    // 地图实况
    mapData: 4,
    bikeStatusControl: 16,
    schoolBus: 173,
    bikeStatus: 45,
    bikeViolationParking: 120, // 单车停车点外
    detainCar: 46,
    // 运维力量
    operationPower: 17,
    operatorPosition: 47,
    operateCarPosition: 48,
    operationPowerNotDivideBiz: 49,
    // 热力图
    heatLayer: 18,
    // 停车点
    parkingArea: 79,
    noParkingArea: 20,
    operationArea: 143,
    // 地图车辆信息
    showBikeId: 63, // 显示bikeId
    showBikeLicenseCode: 86, // 显示车牌号
    showBikeFrameId: 87, // 显示车架号
    showBikeOrder: 144, // 显示车辆订单
    parkingShowDetail: 80, // 显示停车点详情
    parkingShowBikeCount: 81, // 显示停车点车辆数
    // 实时统计数据
    todayStatistic: 5,
    todayOperateCarCounts: 21, // 今日运营车数量
    todayActiveCarCounts: 22, // 今日活跃车数量
    todayOrders: 23, // 今日订单量
    todayRidingDistance: 24, // 今日骑行里程
    currentOperateCarCounts: 88, // 当前运营车总量
    currentActiveCarCounts: 89, // 当前活跃车总量
    currentViolationCounts: 122, // 当前违停车总量
    //车辆信息
    bikeInfo: 6,
    quotaCounts: 25,
    registerCarCounts: 26,
    unRegisterCarCounts: 27,
    registerRate: 28,
    // 运维信息
    operationInfo: 7, // 运维情况模块
    operatorCount: 29, // 运维情况-运维人员数量
    operateCarCount: 30, // 运维情况-运维车数量
    operationInfoNotDivideBiz: 31,
    // 备案扫码信息
    registerScanInfo: 15,
    registerScanStatisticInfo: 32,
    registerScanCityInfo: 33,
    registerScanModule: 141, // 备案扫码模块
    // 订单信息
    orderInfo: 9,
    orderTrendLine: 34,
    activeCarTrendLine: 35,
    orderLatestSeven: 58,
    orderLatestThirty: 59,
    // 数据统计
    dataStatistic: 172,
    // 骑行信息
    ridingInfo: 10,
    ridingDistance: 36,
    heatConsumptionCount: 37,
    replaceDriving: 38,
    carbonReductionCount: 39,
    treePlanting: 40,
    avgRideTime: 41,
    avgRideDistanceCount: 42,
    ridingLatestSeven: 60,
    ridingLatestThirty: 61,
    ridingLatestYear: 170,
    // 实时工单
    realTimeWorkOrder: 11,
    orderStateRoll: 43,
    orderImgShow: 44,
    showCityLevelData: 52,
    reserveWorkOrder: 152,
    reserveWorkOrderRoll: 153,
    reserveWorkOrderImgShow: 154,
    feedbackWorkOrder: 155,
    feedbackWorkOrderRoll: 156,
    feedbackWorkOrderImgShow: 157,

    // 淤积告警
    siltingUpAlarm: 82, // 淤积告警轮播
    operatorPositionInfoDetail: 107, // 运维人员详情明细
    bikeNotCluster: 125, // 地图车辆详情不聚合

    // 自有车
    validLicensePlateCount: 161, // 有效期内号牌数
    cumulativeLicensePlateCount: 162, // 累计绑定号牌数
    ownVehicleManagementCount: 163, // 自有车治理次数
    vehicleDistribution: 164, // 车辆分布
    vehicleOwnerDemographics: 165, // 车主身份分布
    disposalTypeDistribution: 166, // 车辆处置类型
    annualVehicleDisposalStatistics: 167, // 年度处置车辆统计
    dimensionItemYear: 168, // 车辆处置类型 - 今年
    dimensionItemCumulative: 169, // 车辆处置类型 - 累计
  },
  // 后台管理
  backgroundManage: {
    index: 2,
    // 权限管理
    authManage: 55,
    userManage: 12,
    roleManage: 13,
    entityManage: 14,
    // ga数据平台
    gaPlatform: 56,
    autoWhiteList: 57,
    dataPushList: 65,
    addDataPushDep: 66,
    editDataPushDep: 67,
    deleteDataPushDep: 68,
    dataPushDepLog: 69,
    interfaceStatus: 70,
    interfaceManualPush: 71,
    interfacePushResult: 72,
    editInterface: 73,
    interfaceLog: 74,
    // 备案信息管理
    registerManage: 93, // 备案信息管理
    cityRegisterManage: 185, // 城市级备案
    cityRegisterView: 187, // 城市级备案 - 查看
    cityRegisterAdd: 188, // 城市级备案 - 添加
    cityRegisterDelete: 189, // 城市级备案 - 删除
    cityRegisterEdit: 190, // 城市级备案 - 修改
    gEndRegisterManage: 186, // G端分区备案
    gEndRegisterView: 191, // G端分区备案 - 查看
    gEndRegisterAdd: 192, // G端分区备案 - 添加
    gEndRegisterDelete: 193, // G端分区备案 - 删除
    gEndRegisterEdit: 194, // G端分区备案 - 修改
    creditManage: 98, // 信用管理
    creditScoreOpen: 99, // 信用管理-骑行分开通
    creditUserWhiteList: 100, // 信用管理-用户白名单
    creditUserBannedList: 112, // 信用管理-用户负面清单
    operationOptimize: 102, // ga数据平台-运维力量调优
    virtualOrder: 106, // ga数据平台-虚拟订单
    optimizeStrategy: 113, // ga数据平台-调优策略管理
    virtualPosi: 114, // ga数据平台-调优策略-虚拟定位
    areaOptimize: 117, // ga数据平台-调优策略-区域调优目标配置
    bluetoothConfig: 115, // ga数据平台-调优策略-蓝牙信号调优
    xProject: 159, // ga数据平台-调优策略-x项目调优
    xProjectConverse: 118, // ga数据平台-调优策略-x项目调优-X项目换码任务
    xProjectUnbind: 160, // ga数据平台-调优策略-x项目调优-X项目解绑任务
    digitalGuard: 121, // ga数据平台-调优策略-数字哨兵
    redirectDataFilter: 123, // ga数据平台-调优策略-直传车数据过滤调优
    reportManageList: 119, // 汇报页面管理
    dataPushAlert: 126, // 数据对接任务 结果告知/告警配置
    whiteListAlert: 127, // 白名单管理 结果告知/告警配置
    interfaceResend: 128, // 数据对接管理-数据补传
    dataSupplement: 142, // ga数据平台-调优策略-补传申诉调优
    parkingPointDockingRate: 171, // ga数据平台-调优策略-停车点入栏率
    dataQualityMonitor: 181, // ga数据平台-数据对接管理-数据质量监测
    dataIntegrityMonitor: 182, // ga数据平台-数据对接管理-数据质量监测-数据完整性监测
    dataTimelyMonitor: 183, // ga数据平台-数据对接管理-数据质量监测-数据及时性监测
  },
  // 管理中心
  manageCenter: {
    index: 3,
    licenseVerifyTool: 140, // 牌照/扫码核验工具
    registerScanDetail: 8, // 牌照/扫码核验工具 - 牌照扫码记录
    shieldWordsConfig: 130, // 牌照/扫码核验工具 - 牌照屏蔽词
    duplicateCodeConfig: 131, // 牌照/扫码核验工具 - 重牌重码
    complaintOrder: 53,
    firmTest: 62,
    bikeManage: 83, // 车辆管理
    bikeManageChart: 139, //车辆管理 - 图表可视化
    showBikeLicenseCode: 84, // 显示车牌号
    showBikeFrameId: 85, // 显示车架号
    parkingManage: 75, // 停车点管理
    parkingManageExport: 133, // 停车点管理-导出
    showBikeCount: 76, // 显示车辆数
    showParkingPortCapacity: 77, // 显示点位容量
    showSiltingUpAlarm: 78, // 显示淤积告警
    parkingBuffer: 94, // 停车点buffer
    schoolManage: 90, // 校园管理
    schoolAccount: 91, // 小程序账号
    schoolConfigCenter: 92, // 配置中心
    schoolBikeManage: 95, // 校园车辆管理
    schoolBikeRecordManage: 96, // 校园车辆备案号管理
    schoolBikeDealRecord: 97, // 校园车辆处置记录
    userCreditManage: 101, // 用户信用行为管理
    opereationOrder: 103, // 运维工单
    operatorBaseInfo: 108, // 运维人员信息
    operatorBaseInfoOperatorList: 109, // 运维人员信息-列表
    operatorBaseInfoOnlyOutside: 110, // 运维人员信息-仅展示库外运维力量
    operatorBaseInfoNotDistinguishBusiness: 111, // 运维人员信息-不分业务展示
    operationTrajectoryInfo: 145, // 运维人员信息-运维轨迹详情
    bikeManageViewOrderDetail: 124, // 车辆管理-查看订单
    schoolBreatheRecord: 129, // 自有车管理-处置记录
    orderManage: 132, // 管理中心-订单管理
    orderManagePayStatus: 135, // 管理中心-订单管理-支付状态筛选
    exclusiveManage: 134, // 管理中心-专属车管理
    manageReport: 136, // 管理中心-经营日报
    expenseData: 137, // 管理中心-结费数据
    userFeedbackInfo: 149, // 管理中心-用户反馈信息
    userFeedbackInfoDetail: 150, // 管理中心-用户反馈信息-用户意见反馈详情
    userFeedbackInfoAction: 151, // 管理中心-用户反馈信息-操作详情
    userVehicleReservationInfo: 146, // 管理中心-用户单车预约信息
    userVehicleReservationInfoDetail: 147, // 管理中心-用户单车预约信息-用户车辆预约详情
    userVehicleReservationInfoAction: 148, // 管理中心-用户单车预约信息-操作详情
    schoolConfigCenterMiniProgram: 174,
    schoolConfigCenterIdInfo: 175,
    schoolConfigCenterDealtype: 176,
    schoolConfigCenterMessageAlert: 177,
    schoolConfigCenterDataShow: 178,
    schoolConfigCenterBikeMark: 179,
    schoolConfigCenterSettings: 180,
  },
}
